import React from 'react';
import LivePreview from './LivePreview';
import { getTemplateFiles } from '../templates';

/**
 * Single preview path for template UIs: modal, workspace, and editor all use the same file map.
 */
export default function TemplateFilePreview({ files, templateType, style, projectId, jobId, onFilesUpdated, onRuntimeError, onElementEditRequest }) {
  const previewFiles =
    files && Object.keys(files).length > 0
      ? files
      : templateType
        ? getTemplateFiles(templateType)
        : null;

  if (!previewFiles || Object.keys(previewFiles).length === 0) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100%', color: '#64748b', fontSize: 13, ...style,
      }}>
        No previewable template files
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100%', minHeight: 320, position: 'relative', ...style }}>
      <LivePreview files={previewFiles} projectId={projectId} jobId={jobId} onFilesUpdated={onFilesUpdated} onRuntimeError={onRuntimeError} onElementEditRequest={onElementEditRequest} />
    </div>
  );
}
